import { CartAddEvent } from '@theme/events';

class WpblCapOffer extends HTMLElement {
  static adding = false;

  connectedCallback() {
    this.addEventListener('submit', this.addCap);
    this.querySelector('button').disabled = WpblCapOffer.adding;
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.addCap);
  }

  async readCart() {
    const response = await fetch(`${Theme.routes.cart_url}.js`, { cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to check your cart. Please try again.');
    return response.json();
  }

  updateCart(cart, sections) {
    document.dispatchEvent(new CartAddEvent(cart, 'wpbl-cap-offer', {
      source: 'wpbl-cap-offer',
      productId: this.dataset.productId,
      itemCount: cart.item_count,
      sections,
    }));
  }

  addCap = async (event) => {
    event.preventDefault();
    if (WpblCapOffer.adding) return;
    WpblCapOffer.adding = true;
    this.dataset.state = 'adding';
    const status = this.querySelector('[role="status"]');
    status.textContent = 'Adding your cap…';
    document.querySelectorAll('wpbl-cap-offer button').forEach((button) => { button.disabled = true; });
    this.setAttribute('aria-busy', 'true');

    try {
      const cart = await this.readCart();
      const productId = Number(this.dataset.productId);
      const hasCap = cart.items.some((item) => item.product_id === productId);
      const qualifies = cart.items.some((item) => item.product_id !== productId && !item.gift_card && item.product_type !== 'Gift Card' && item.original_price > 0);
      if (hasCap || !qualifies) {
        status.textContent = hasCap ? 'Your cap is already in the cart.' : 'Add another item to qualify for this offer.';
        this.updateCart(cart);
        return;
      }

      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((element) => element.dataset.sectionId))].slice(0, 5);
      const body = new FormData(event.target);
      body.set('sections', sections.join(','));
      body.set('sections_url', window.location.pathname);
      const response = await fetch(Theme.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'This cap could not be added. Please try again.');

      let updatedCart;
      try {
        updatedCart = await this.readCart();
      } catch {
        window.location.assign(Theme.routes.cart_url);
        return;
      }
      status.textContent = 'Cap added to your cart.';
      this.updateCart(updatedCart, result.sections);
    } catch (error) {
      this.dataset.state = 'error';
      status.textContent = error instanceof Error ? error.message : 'Unable to add your cap. Please try again.';
    } finally {
      WpblCapOffer.adding = false;
      this.removeAttribute('aria-busy');
      if (this.dataset.state === 'adding') this.dataset.state = 'idle';
      document.querySelectorAll('wpbl-cap-offer button').forEach((button) => { button.disabled = false; });
    }
  };
}

if (!customElements.get('wpbl-cap-offer')) customElements.define('wpbl-cap-offer', WpblCapOffer);
